module.exports = __webpack_public_path__ + "app-static/img/cake.601a099e.gif";